"use client";

import type { InputHTMLAttributes, FC, Ref } from "react";
import { mergeClasses } from "@huub-web/utils";
import type { RecipeVariants } from "@vanilla-extract/recipes";

import { containerStyle, checkboxStyle, knobStyle } from "./Switch.css";
import { elevations } from "../../theme/css/elevations.css";
import { focusWithin } from "../../theme/css/focusVisible.css";

export type SwitchProps = Omit<InputHTMLAttributes<HTMLInputElement>, "size"> &
  RecipeVariants<typeof containerStyle> & {
    checked?: boolean;
    label?: string;
    /**
     * Ref forwarded to the root element
     */
    ref?: Ref<HTMLInputElement>;
  };

/**
 * A switch component.
 */
export const Switch: FC<SwitchProps> = ({
  className,
  checked,
  size = "m",
  variant = "primary",
  ref,
  ...props
}) => (
  <label
    className={mergeClasses(
      containerStyle({
        checked: !!checked,
        size,
        variant,
        disabled: !!props.disabled,
      }),
      focusWithin,
      className,
    )}
    {...(!!props.disabled && { "aria-disabled": true })}
  >
    <input
      ref={ref}
      type="checkbox"
      checked={checked}
      className={checkboxStyle}
      {...props}
    />
    <span
      className={mergeClasses(
        knobStyle({ checked: !!checked, size, variant }),
        elevations.l,
      )}
    />
  </label>
);
